import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  BackofficeOrganizationsResponseDataSchema,
  DataResponseWithPagination,
  GetBackofficeOrganizationsSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeOrganizationsSchema>
type Response = DataResponseWithPagination<
  z.infer<typeof BackofficeOrganizationsResponseDataSchema>
>
type OnSuccessFn = (data: Response) => void

export const getBackofficeOrganizationsQueryKey = (query: Query = {}) => [
  "backofficeOrganizations",
  query,
]

type Props = {
  query?: Query
  onSuccess?: OnSuccessFn
}

export const getBackofficeOrganizationsQuery = ({ query, onSuccess }: Props = {}) => {
  return queryOptions({
    queryKey: getBackofficeOrganizationsQueryKey(query),
    queryFn: async () => {
      const { data } = await axios.get<Response>("/backoffice/organizations", { params: query })
      onSuccess?.(data)
      return data.data
    },
  })
}
